import { PipeTransform, Pipe } from '@angular/core';
import { pipe } from 'rxjs';
import { CollectionManagementResult } from '../models/collectionManagementResult.model';
import { CollectionManagement } from '../models/collectionManagement.model';

@Pipe({
    name: 'managementResultFilter'
})

export class ManagementResultFilterPipe implements PipeTransform {
  transform(items: CollectionManagementResult[], args: any) {

    if (args.hasOwnProperty('fkIdManagementResult') && typeof items !== 'undefined') {

      let filteredItems = items.filter(item => item.idCollectionManagementResult == args.fkIdManagementResult);

      if (filteredItems.length > 0) {

        return filteredItems[0].rResultName.toUpperCase();

      } else {
        if (args.managementObservation.includes("Envio")) {
          return "ENVIO DE CARTA";
        }

        if (args.managementObservation.includes("Devolucion")) {
          return "DEVOLUCION DE CARTA";
        }

        return "Sin resultado";
      }
    }

    return "Sin resultado";
  }      
}
